/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_SubtitleInputs */

const tr_cerez_subtitle = /** @type {(inputs: Cerez_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™'in çerez kullanımı, kategorileri ve sizin bunlar üzerindeki kontrolünüz hakkında detaylı bilgi.`)
};

const en_cerez_subtitle = /** @type {(inputs: Cerez_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed information about ShopPanel™'s use of cookies, their categories and the control you have over them.`)
};

const de_cerez_subtitle = /** @type {(inputs: Cerez_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführliche Informationen zur Cookie-Nutzung von ShopPanel™, zu den Kategorien und zu Ihrer Kontrolle darüber.`)
};

const ru_cerez_subtitle = /** @type {(inputs: Cerez_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробная информация об использовании файлов cookie в ShopPanel™, об их категориях и о вашем контроле над ними.`)
};

/**
* | output |
* | --- |
* | "Detailed information about ShopPanel™'s use of cookies, their categories and the control you have over them." |
*
* @param {Cerez_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_subtitle = /** @type {((inputs?: Cerez_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_subtitle(inputs)
	if (locale === "de") return de_cerez_subtitle(inputs)
	if (locale === "ru") return ru_cerez_subtitle(inputs)
	return tr_cerez_subtitle(inputs)
});